export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/9BiE1sLQKH2ER3q49248sq/PAGINA_7.png',
    alt: 'Sample page Every Food Is a Mix of the Same Few Building Blocks, a food composition map of water, carbohydrates, proteins, fats and oils, vitamins and minerals',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oNcM9M2CdGc6DdwWvvy8Pp/PAGINA_14.png',
    alt: 'Sample page It Is Not How Much Water, But How Available It Is, comparing water activity and moisture content',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iXFoFojJHg9LUx2mFbLfui/PAGINA_20.png',
    alt: 'Sample page Temperature Is the Control You Use Every Day, showing the temperature danger zone, chilled and frozen storage',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1ofjRepngmzvLVB4zN3oMK/PAGINA_28.png',
    alt: 'Sample page Food Moves Through the Plant in a Fixed Order, the typical production flow of a food plant from receiving to dispatch',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rpt39G2kygJFPQd9hpXuV8/PAGINA_32.png',
    alt: 'Sample page Food and People Move in One Direction, a plant layout showing one-way flow and segregation of raw and cooked areas',
  },
];
